import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, MedicalNotesIcon } from "../../../Icons";
import { getCarePlanLibraryMeta } from "../../../services/librariesCatalogService";
import { LIBRARIES_THEME } from "../librariesTheme";
import {
  CARE_PLAN_META_SECTIONS,
  CARE_PLAN_SECTIONS,
} from "./carePlanSections";

const SectionCard = ({ item, to }) => (
  <Link
    to={to}
    className="group flex items-start gap-3 rounded-xl border border-indigo-100 bg-white px-3.5 py-3 shadow-sm transition-colors hover:border-indigo-300 hover:bg-indigo-50/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
  >
    <span
      className={`mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${LIBRARIES_THEME.section.badge}`}
    >
      <MedicalNotesIcon size={14} className={LIBRARIES_THEME.section.icon} />
    </span>
    <span className="min-w-0 flex-1">
      <span className="flex items-center justify-between gap-2">
        <span className={`text-sm font-semibold ${LIBRARIES_THEME.section.title}`}>
          {item.label}
        </span>
        <ChevronRightIcon
          size={14}
          className="shrink-0 text-indigo-300 transition-transform group-hover:translate-x-0.5 group-hover:text-indigo-600"
        />
      </span>
      <span className="mt-0.5 block text-xs leading-snug text-slate-500">
        {item.description}
      </span>
    </span>
  </Link>
);

const CarePlanLibraryHub = () => {
  const [sections, setSections] = useState(CARE_PLAN_SECTIONS);
  const [metaSections, setMetaSections] = useState(CARE_PLAN_META_SECTIONS);

  useEffect(() => {
    let cancelled = false;
    getCarePlanLibraryMeta()
      .then((meta) => {
        if (cancelled || !meta) return;
        if (Array.isArray(meta.sections) && meta.sections.length) {
          setSections(meta.sections);
        }
        if (Array.isArray(meta.metaSections) && meta.metaSections.length) {
          setMetaSections(meta.metaSections);
        }
      })
      .catch(() => {
        /* offline / first load — local constants already set */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="space-y-5">
      <section className="space-y-2.5">
        <div className="flex items-center gap-2 px-0.5">
          <span
            className={`w-0.5 h-4 rounded-full shrink-0 ${LIBRARIES_THEME.section.bar}`}
            aria-hidden
          />
          <h3
            className={`text-xs font-semibold uppercase tracking-wide ${LIBRARIES_THEME.section.title}`}
          >
            Section Template Libraries
          </h3>
          <span
            className={`inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded px-1.5 text-[10px] font-semibold tabular-nums ${LIBRARIES_THEME.section.badge}`}
          >
            {sections.length}
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2.5">
          {sections.map((item) => (
            <SectionCard
              key={item.key}
              item={item}
              to={`/libraries/care-plan-templates/${item.key}`}
            />
          ))}
        </div>
      </section>

      <section className="space-y-2.5">
        <div className="flex items-center gap-2 px-0.5">
          <span
            className={`w-0.5 h-4 rounded-full shrink-0 ${LIBRARIES_THEME.section.bar}`}
            aria-hidden
          />
          <h3
            className={`text-xs font-semibold uppercase tracking-wide ${LIBRARIES_THEME.section.title}`}
          >
            Category Libraries
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
          {metaSections.map((item) => (
            <SectionCard
              key={item.key}
              item={item}
              to={`/libraries/care-plan-templates/${item.key}`}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default CarePlanLibraryHub;
